var path = '/registration/form/form-survey-text.html';
var html = "<input type=\"text\" class=\"form-control\" id=\"field_{{$ctrl.field.key}}\"\n   ng-model=\"$ctrl.surveyValue\"\n   ng-required=\"$ctrl.field.required\">\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;